// src/components/WorkoutDetails/TimerControl.js
import React from "react";
import TimerButton from "../../common/TimerButton";
import SetsButton from "../../common/SetsButton";
import SuccessButton from "../../common/SuccessButton";

const TimerControl = ({ exercise, state, setExerciseStates }) => {
  // Handler for when the SetsButton is clicked
  const handleSetsButtonClick = () => {
    setExerciseStates((prevStates) => ({
      ...prevStates,
      [exercise.exercise_id]: {
        ...prevStates[exercise.exercise_id],
        sets: prevStates[exercise.exercise_id].sets + 1,
        countdown: exercise.rest_seconds,
        timerActive: true,
      },
    }));
  };

  return (
    <>
      {!state.completed ? (
        <>
          <SetsButton onClick={handleSetsButtonClick} label={state.timerActive ? state.sets : "+"} />
          <TimerButton countdown={state.countdown} disabled={state.timerActive || state.completed} />
        </>
      ) : (
        <SuccessButton />
      )}
    </>
  );
};

export default TimerControl;
